import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=8f8462c0&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8462c0",
  null
  
)

export default component.exports